import { jsx as _jsx } from "react/jsx-runtime";
import * as Colors from './colors';
import { split } from './common';
export function renderTs(source) {
    const parts = split(source);
    const result = [];
    const keyWords = ['export', 'function', 'if', 'else', 'switch', 'case', 'default', 'for', 'while', 'do', 'break', 'continue', 'return',
        'try', 'catch', 'finally', 'throw', 'new', 'class', 'extends', 'implements', 'interface', 'abstract', 'private', 'protected',
        'public', 'static', 'readonly', 'let', 'const', 'var', 'type', 'enum', 'namespace', 'module', 'import', 'from', 'as',
        'default', 'null', 'undefined', 'true', 'false', 'this', 'super', 'void', 'any', 'never', 'unknown', 'number', 'string',
        'boolean', 'object', 'symbol', 'bigint', 'Array', 'Promise', 'Map', 'Set', 'WeakMap', 'WeakSet', 'Date', 'RegExp', 'Error'];
    let isString = false;
    for (const token of parts) {
        if (keyWords.indexOf(token) >= 0) {
            result.push(_jsx("span", { style: { color: Colors.elementColor }, children: token }));
            continue;
        }
        else if (token === '(' || token === ')' || token === '{' || token === '}' || token === '[' || token === ']') {
            result.push(_jsx("span", { style: { color: Colors.signColor }, children: token }));
            continue;
        }
        if (token === '"' || token === '\'') {
            result.push(_jsx("span", { style: { color: Colors.attributeValueColor }, children: token }));
            isString = !isString;
            continue;
        }
        result.push(_jsx("span", { style: { color: isString ? Colors.attributeValueColor : Colors.defaultColor }, children: token }));
    }
    return result;
}
